import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

// search module
import { NgPipesModule } from "ngx-pipes";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { LayoutsModule } from "./layouts/layouts.module";
import { PagesModule } from "./pages/pages.module";

// Auth
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";

// Language
import { TranslateModule } from "@ngx-translate/core";

// Store
import { rootReducer } from "./store";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";

//interceptor
import { ResInterceptor } from "./core/interceptor/res-interceptor.interceptor";
import { ReqInterceptor } from "./core/interceptor/req-intercept.interceptor";
import { DispatcherScopeInterceptor } from "./core/interceptor/dispatcher-scope.interceptor";
import { LoaderModule } from "./loader/loader.module";

//toaster
import { ToastrModule } from "ngx-toastr";
import { Helper } from "./core/helpers/helper";
import { CommonService } from "./shared/services/common.service";
import { LanguageService } from "./core/services/language.service";
import { DatePipe } from "@angular/common";

const load = (config: CommonService, languageService: LanguageService, helper: Helper): (() => Promise<boolean>) => {
  return async () => {
    try {
      if (!helper.userToken) {
        if (localStorage.getItem("loginDeviceToken")) {
          await config.getLoginToken(localStorage.getItem("loginDeviceToken"));
        } else {
          await config.getLoginToken();
        }
      } else {
        await config.loadScripts();
      }
      
      await languageService.init();

      return true;
    } catch (err) {
      return false;
    }
  };
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    StoreModule.forRoot(rootReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production // Restrict extension to log-only mode
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      progressBar: true,
      progressAnimation: "increasing"
    }),
    PagesModule,
    NgPipesModule,
    LoaderModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DispatcherScopeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: load,
      deps: [CommonService, LanguageService, Helper],
      multi: true
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
